class SearchModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector(".modal__close-button").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.querySelector(".offcanvas-overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.ensureDesktopSearchBar();
    this.ensureMobileHeaderSearch();
    this.cleanupDuplicateHeaderSearch();
    this.setHeaderSearchIconAccessibility();
    this.fixSearchPagePrices();
  }

  ensureDesktopSearchBar() {
    const headerBottom = document.querySelector(
      "#shopify__header__section .header_bottom.top_center"
    );
    if (!headerBottom) return;
    if (headerBottom.querySelector(".pkw-search-bar")) return;

    // Remove old nav search icon if present
    const oldSearchLi = headerBottom.querySelector(".header__menu_li--search");
    if (oldSearchLi) oldSearchLi.remove();

    const searchBar = document.createElement("div");
    searchBar.className = "pkw-search-bar";
    searchBar.innerHTML = `
      <form action="/search" method="get" role="search" class="pkw-search-bar__form">
        <input type="hidden" name="type" value="product">
        <input type="hidden" name="options[prefix]" value="last">
        <div class="pkw-search-bar__inner">
          <svg class="pkw-search-bar__icon" aria-hidden="true" focusable="false" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="m10 .75c5.105 0 9.25 4.145 9.25 9.25s-4.145 9.25-9.25 9.25-9.25-4.145-9.25-9.25 4.145-9.25 9.25-9.25zm0 1.5c-4.277 0-7.75 3.473-7.75 7.75s3.473 7.75 7.75 7.75 7.75-3.473 7.75-7.75-3.473-7.75-7.75-7.75z"></path><path d="m10 4.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c2.346 0 4.415 1.2 5.625 3.019.229.344.135.81-.21 1.04-.344.229-.81.135-1.04-.21-.941-1.415-2.55-2.349-4.375-2.349z"></path><path d="m15.47 16.53c-.293-.292-.293-.768 0-1.06.292-.293.768-.293 1.06 0l6.5 6.5c.293.292.293.768 0 1.06-.292.293-.768.293-1.06 0z"></path></g></svg>
          <input
            type="search"
            name="q"
            class="pkw-search-bar__input"
            placeholder="Produkte suchen..."
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
          >
          <button type="submit" class="pkw-search-bar__submit" aria-label="Suchen">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14M12 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      </form>
    `;
    headerBottom.appendChild(searchBar);
  }

  ensureMobileHeaderSearch() {
    const headerActions = document.querySelector(
      "#shopify__header__section .header__actions"
    );
    if (!headerActions) return;
    if (headerActions.querySelector(".js-search-trigger")) return;

    const searchBtn = document.createElement("button");
    searchBtn.className =
      "header__actions_btn header__actions_btn--mobile-search js-search-trigger";
    searchBtn.setAttribute("aria-label", "Suchen");
    searchBtn.setAttribute("role", "button");
    searchBtn.setAttribute("aria-haspopup", "dialog");
    searchBtn.innerHTML = `<svg class="icon icon-search" aria-hidden="true" focusable="false" role="presentation" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="Icon"><path d="m10 .75c5.105 0 9.25 4.145 9.25 9.25s-4.145 9.25-9.25 9.25-9.25-4.145-9.25-9.25 4.145-9.25 9.25-9.25zm0 1.5c-4.277 0-7.75 3.473-7.75 7.75s3.473 7.75 7.75 7.75 7.75-3.473 7.75-7.75-3.473-7.75-7.75-7.75z"></path><path d="m10 4.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c2.346 0 4.415 1.2 5.625 3.019.229.344.135.81-.21 1.04-.344.229-.81.135-1.04-.21-.941-1.415-2.55-2.349-4.375-2.349z"></path><path d="m15.47 16.53c-.293-.292-.293-.768 0-1.06.292-.293.768-.293 1.06 0l6.5 6.5c.293.292.293.768 0 1.06-.292.293-.768.293-1.06 0z"></path></g></svg>`;
    headerActions.prepend(searchBtn);
  }

  fixSearchPagePrices() {
    if (!document.querySelector(".template-search")) return;
    const fix = () => {
      document.querySelectorAll(".template-search .pkw-card-price__value, .template-search .pkw-premium-card__price-value").forEach((el) => {
        el.style.setProperty("background", "transparent", "important");
        el.style.setProperty("color", "#ebc878", "important");
      });
    };
    fix();
    setTimeout(fix, 500);
    setTimeout(fix, 1500);
    setTimeout(fix, 4000);
    new MutationObserver(fix).observe(
      document.querySelector(".template-search"),
      { childList: true, subtree: true }
    );
  }

  cleanupDuplicateHeaderSearch() {
    document
      .querySelectorAll(
        "#shopify__header__section .header_bottom.top_center .header__nav-search"
      )
      .forEach((entry) => entry.remove());
  }

  setHeaderSearchIconAccessibility() {
    const searchIconButtons = document.querySelectorAll(
      "#header_search__action, .js-search-trigger"
    );
    searchIconButtons.forEach((searchIconButton) => {
      searchIconButton.setAttribute("role", "button");
      searchIconButton.setAttribute("aria-haspopup", "dialog");
      searchIconButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(searchIconButton);
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const focusElement =
          this.querySelector(".search__content_inner") ||
          this.querySelector(".modal__close-button");
        trapFocus(focusElement);
      },
      { once: true }
    );
    document.body.classList.add("body-overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("body-overflow-hidden");
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("search-modal", SearchModal);
